import React, {useEffect, useRef, useState} from 'react';
import {Button, Callout, Drawer, FormGroup, HTMLSelect, InputGroup, Switch} from '@blueprintjs/core';
import styled from 'styled-components';
import {authPkgConfig} from '@auravisionlabs/aura-pkg-auth-service';

import * as AuthAPI from '../../../../services/auth-api';


const FormWrapper = styled.form`
    width: 90%;
    margin: 2em auto;
`;

const CreateCapability = ({isOpen, onClose}) => {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState({});
    const nameInput = useRef(null);
    const [resource, setResource] = useState('');
    const [iotCommandName, setIotCommandName] = useState('');
    const [canCreate, setCanCreate] = useState(false);
    const [canRead, setCanRead] = useState(false);
    const [canUpdate, setCanUpdate] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [visibility, setVisibility] = useState('own org');
    const [auraAdminOnly, setAuraAdminOnly] = useState(false);

    useEffect(() => {
        if (isOpen) {
            if (nameInput.current) nameInput.current.focus();
            setResponse({});
        }
    }, [isOpen]);

    const formSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponse({});

        try {
            const newCapability = {
                name: nameInput.current.value,
                resource,
                canCreate,
                canRead,
                canUpdate,
                canDelete,
                visibility,
                auraAdminOnly,
            };
            if (newCapability.resource === authPkgConfig.resources.deviceIOTSingleCommand) {
                newCapability.resource = `${newCapability.resource}${iotCommandName}`;
            }
            await AuthAPI.capabilities.create(newCapability);
            setResponse({type: 'success', text: 'Capability added'});
        } catch (err) {
            setResponse({type: 'warning', text: 'There was an error'});
        }

        setLoading(false);
    };

    return (
        <Drawer
            icon="plus"
            title="Add a new capability"
            isOpen={isOpen}
            onClose={onClose}
        >
            <FormWrapper onSubmit={formSubmit}>
                <FormGroup label="Capability Name" labelFor="cap-name">
                    <InputGroup id="cap-name" inputRef={nameInput} required />
                </FormGroup>
                <FormGroup label="Resource" labelFor="cap-resource">
                    <HTMLSelect
                        id="cap-resource"
                        onChange={(e) => setResource(e.target.value)}
                        options={Object.values(authPkgConfig.resources)}
                        value={resource}
                    />
                </FormGroup>
                {resource === authPkgConfig.resources.deviceIOTSingleCommand && (
                    <FormGroup label="Name of IoT Command to give access to" labelFor="cap-iot">
                        <InputGroup
                            id="cap-iot"
                            onChange={(e) => setIotCommandName(e.target.value)}
                            value={iotCommandName}
                        />
                    </FormGroup>
                )}
                <Switch label="Can Create" checked={canCreate} onChange={() => setCanCreate(v => !v)} />
                <Switch label="Can Read" checked={canRead} onChange={() => setCanRead(v => !v)} />
                <Switch label="Can Update" checked={canUpdate} onChange={() => setCanUpdate(v => !v)} />
                <Switch label="Can Delete" checked={canDelete} onChange={() => setCanDelete(v => !v)} />
                <FormGroup label="Visibility" labelFor="cap-visibility">
                    <HTMLSelect
                        id="cap-visibility"
                        onChange={(e) => setVisibility(e.target.value)}
                        options={['all org', 'own org', 'personal']}
                        value={visibility}
                    />
                </FormGroup>
                <Switch label="Aura Admin Only" checked={auraAdminOnly} onChange={() => setAuraAdminOnly(v => !v)} />

                <Button type="submit" loading={loading} intent="primary">
                    Create capability
                </Button>
                {response.type && (
                    <Callout intent={response.type} style={{marginTop: 8}}>
                        {response.text}
                    </Callout>
                )}
            </FormWrapper>
        </Drawer>
    );
};

export {CreateCapability};
